import { kpiTypes } from 'helpers/constants';
import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import { paramListForChartDataRequest } from '../helpers';
import { Trend } from './Trend';
import { HistogramV2 } from './Histogram V2';
import { ScatterPlotV2 } from './ScatterPlot V2';

const GraphComponent = ({ model, actions, isComparisonView, offGraphSignalsCount }) => {
    const [isZoomed, setIsZoomed] = useState(false);
    // skip the first run so stale chartData from V2 does not trigger a re-fetch into V1
    const isFirstDateSelectionRun = useRef(true);

    const onKPISelection = () => {
        if (
            model.selectedKpi &&
            model.dateSelection.to &&
            model.dateSelection.from &&
            model.asset
        ) {
            actions.getChartData(model.selectedKpi, model.asset, model.selectedKPIType, model.activeTab);
        }
    };

    useEffect(() => {
        onKPISelection();
    }, [model.selectedKpi]);

    useEffect(() => {
        if (isFirstDateSelectionRun.current) {
            isFirstDateSelectionRun.current = false;
            return;
        }
        setIsZoomed(false);
        if (model.chartData && model.chartData.length) {
            const list = paramListForChartDataRequest(model.chartData, model.selectedKPIType, model.activeTab);
            actions.getChartDataForNewDate(list, false, model.dateSelection.from, model.dateSelection.to, model.selectedKPIType, model.activeTab);
        }
    }, [model.dateSelection]);


    if (model.selectedKPIType) {
        switch (model.selectedKPIType) {
            case kpiTypes.HISTOGRAM: {
                return <HistogramV2
                    asset={model.asset}
                    chartData={model.chartData}
                    removeKPIData={actions.removeKPIData}
                    chartLoadingStatus={model.chartLoadingStatus}
                    chartErrorData={model.chartErrorData}
                    isZoomed={isZoomed}
                    setIsZoomed={setIsZoomed}
                    isComparisonView={isComparisonView}
                    offGraphSignalsCount={offGraphSignalsCount}
                />;
            }
            case kpiTypes.SCATTER: {
                return <ScatterPlotV2
                    asset={model.asset}
                    chartData={model.chartData}
                    removeKPIData={actions.removeKPIData}
                    chartLoadingStatus={model.chartLoadingStatus}
                    chartErrorData={model.chartErrorData}
                    isZoomed={isZoomed}
                    setIsZoomed={setIsZoomed}
                    isComparisonView={isComparisonView}
                    offGraphSignalsCount={offGraphSignalsCount}
                />;
            }
            default:
                return <Trend
                    asset={model.asset}
                    chartData={model.chartData}
                    selectedKPIType={model.selectedKPIType}
                    removeKPIData={actions.removeKPIData}
                    chartLoadingStatus={model.chartLoadingStatus}
                    chartErrorData={model.chartErrorData}
                    setIsZoomed={actions.setIsZoomed}
                    zoomInToSelectedTrendKpiData={actions.zoomInToSelectedTrendKpiData}
                    resetChartData={actions.resetChartData}
                    isComparisonView={isComparisonView}
                    offGraphSignalsCount={offGraphSignalsCount}
                />;
        }
    }
};

GraphComponent.propTypes = {
    isComparisonView: PropTypes.bool,
    offGraphSignalsCount: PropTypes.number,
    actions: PropTypes.shape({
        getChartData: PropTypes.func,
        getChartDataForNewDate: PropTypes.func,
        removeKPIData: PropTypes.func,
        setIsZoomed: PropTypes.func,
        zoomInToSelectedTrendKpiData: PropTypes.func,
        resetChartData: PropTypes.func
    }),
    model: PropTypes.shape({
        selectedKpi: PropTypes.object,
        dateSelection: PropTypes.shape({
            from: PropTypes.any,
            to: PropTypes.any
        }),
        asset: PropTypes.object,
        isZoomed: PropTypes.bool,
        chartData: PropTypes.array,
        selectedKPIType: PropTypes.number,
        chartLoadingStatus: PropTypes.string,
        activeTab: PropTypes.string, // Added validation for activeTab
        chartErrorData: PropTypes.object
    })
};

export default GraphComponent;
